import React from 'react'
import "./Task_income.css"
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Withdraw_tab_contant from '../../../recharge_wallate/withdraw_tab_contant/Withdraw_tab_contant'
import Task_income_cards_section from './task_income_cards_section/Task_income_cards_section';

function Task_income() {
    const breadcrumbData = [
        { label: "wallet", path: "/main-wallet", active: false },
        { label: "TASK INCOME", active: true }
    ];
    return (
        <>
            <section className='Task_income upgraded_menu_sections wallet_inner_banner_section'>
                <div className="container">
                    <Common_recharge_page_banner title="TASK INCOME" className="Upgraded_menu_banner" breadcrumbItems={breadcrumbData} />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Task_income_cards_section />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Task_income